import { SxProps } from '@mui/material'
import { FONT_WEIGHTS } from '@/styles'
import { inputDimensions } from '../Input.style'
import { inputClasses } from '../Input.data'

interface InputLabelStyles {
  label: SxProps
}

export const inputLabelStyles: InputLabelStyles = {
  label: {
    typography: 'textSmMedium',
    color: 'text.secondary700',
    pointerEvents: 'none',

    [`.${inputClasses.state.disabled} &`]: {
      color: 'text.disabled',
    },

    [`.${inputClasses.state.error} &`]: {
      color: 'error.main',
    },

    [`.${inputClasses.label.placement.inside} &`]: {
      position: 'absolute',
      top: 0,
      left: 0,
      typography: 'textMd',
      color: 'text.placeHolder',
      transform: `translate(${inputDimensions.inputPaddingXInPx}px, 10px)`,
      transition: 'all 0.2s',

      [`&.${inputClasses.label.shrink}`]: {
        transform: `translate(${inputDimensions.inputPaddingXInPx}px, -2px)`,
        fontSize: '10px',
        fontWeight: FONT_WEIGHTS.STRONG,
        color: 'text.secondary700',
      },
    },

    // when label is inside and input has error
    [`.${inputClasses.label.placement.inside}.${inputClasses.state.error} &`]: {
      [`&.${inputClasses.label.shrink}`]: {
        color: 'error.main',
      },
    },

    // when label is inside and input is disabled
    [`.${inputClasses.label.placement.inside}.${inputClasses.state.disabled} &`]: {
      color: 'text.placeHolderSubtle',
      [`&.${inputClasses.label.shrink}`]: {
        color: 'text.disabled',
      },
    },

    // when label is inside and has start icon
    [`.${inputClasses.label.placement.inside}.${inputClasses.state.startAdornment} &`]: {
      transform: `translate(${inputDimensions.inputPaddingXInPx + inputDimensions.adornmentSize + inputDimensions.inputGapInPx}px, 10px)`,

      [`&.${inputClasses.label.shrink}`]: {
        transform: `translate(${inputDimensions.inputPaddingXInPx}px, -2px)`,
      },
    },
  },
}
